import React, { useState } from "react";
import MapTo from "../../utils/mapto";
import styled from "styled-components";
import Video from "../Video/Video";
import playIcon from "@images/icons/play.svg";
import GTM from "@utils/GTM";
const StyledContainer = styled.div`
    background: ${props => props.backgroundColor || 'transparent'};
    box-shadow: ${props => props.backgroundShadow || 'none'};
    width: 100%;
    max-width: 100%;
`;

const DefaultCard = (props) => {
    const [showVideo, setShowVideo] = useState({});

    const items = props?.items || props?.content?.items;
    const backgroundColor = props?.backgroundColor?.trim() || (props.content && props?.content.backgroundColor?.trim());
    const backgroundShadow = props?.backgroundShadow?.trim() || (props.content && props?.content.backgroundShadow?.trim());
    const borderRadius = props.borderRadius || (props.content && props.content.borderRadius);
    const borderRadiusTop = props.borderRadiusTop || (props.content && props.content.borderRadiusTop);
    const borderRadiusBottom = props.borderRadiusBottom || (props.content && props.content.borderRadiusBottom);

    // Separate media and content items
    const mediaItems = items?.filter(item => item.__typename === "ContentfulMedia") || [];
    const contentItems = items?.filter(item => item.__typename === "ContentfulRichText") || [];
    const videoItems = items?.filter(item => item.__typename === "ContentfulVideo") || [];

    const playVideo = (mediaId, videoItem) => {
        setShowVideo(prev => ({ ...prev, [mediaId]: videoItem }));
    };

    // Function to construct a Vimeo URL from videoId
    const getVimeoUrl = (videoId, videoHash) => {
        // Return direct embed URL for better compatibility with autoplay parameter
        return `https://player.vimeo.com/video/${videoId}${videoHash ? `?h=${videoHash}&` : '?'}autoplay=1`;
    };

    return (
        <StyledContainer
            backgroundColor={backgroundColor}
            backgroundShadow={backgroundShadow}
            className={`flex-1 relative flex flex-col items-center justify-start w-full ${borderRadius ? ` rounded-all_48` : ''}${borderRadiusTop ? ` rounded-top_48` : ''}${borderRadiusBottom ? ` rounded-bottom_48` : ''} ${props?.style?.cardContainer}`}
        >
            {contentItems.length > 0 && (
                <div className={`default-card__content pt-[20px] pb-[20px] flex flex-col w-full ${props?.style?.contentContainer}`}>
                    {contentItems.map(item => (
                        <MapTo key={item.id} items={item} />
                    ))}
                </div>
            )}

            {mediaItems.length > 0 && (
                <div className={`default-card__media flex justify-center  items-center w-full ${props?.style?.mediaContainer}`}>
                    {mediaItems.map(item => (
                        <div key={item.id} className="relative w-full">
                            {showVideo[item.id] ? (
                                <div className="w-full aspect-video">
                                    {/* Use direct iframe for Vimeo for better compatibility */}
                                    <iframe
                                        src={getVimeoUrl(showVideo[item.id].videoId, showVideo[item.id].videoHash)}
                                        title={showVideo[item.id].videoTitle || "Video"}
                                        className="w-full h-full rounded-bottom_48"
                                        frameBorder="0"
                                        allow="autoplay; fullscreen; picture-in-picture"
                                        allowFullScreen
                                    ></iframe>
                                </div>
                            ) : (
                                <>
                                    <MapTo items={item} className={`w-full ${borderRadius ? ` rounded-bottom_48` : ''}${borderRadiusTop ? ` rounded-top_48` : ''}${borderRadiusBottom ? ` rounded-bottom_48` : ''}`} />

                                    {videoItems.length > 0 && (
                                        <button
                                                className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 text-[#7AC593] hover:text-black z-10 watch-video"
                                                onClick={() => {
                                                    playVideo(item.id, videoItems[0]);
                                                    GTM.videoStart(videoItems[0]?.videoTitle);
                                                }}
                                        >
                                            <img src={playIcon} alt="Play" />
                                        </button>
                                    )}
                                </>
                            )}
                        </div>
                    ))}
                </div>
            )}

            {/* Uncomment if you want to show videos separately
            {videoItems.length > 0 && (
                <div className={`default-card__video flex justify-center items-center ${props?.style?.videoContainer}`}>
                    {videoItems.map(item => (
                        <Video key={item.id} content={item} />
                    ))}
                </div>
            )} */}

        </StyledContainer>
    );
};

export default DefaultCard; 